import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import type {CreatedRequest, OfferBook} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

export function fetchConfirmOfferDeprecated(offerId: string): Promise<CreatedRequest> {
  return fetch<OfferBook, CreatedRequest, CreatedRequest>({
    method: 'POST',
    url: addQuery(externalApiURL('platform/integration/offers/confirm'), {country: appConfig.countryCode}),
    body: {
      offer_id: offerId,
    },
  })
}
